import React, { useEffect, useState } from "react";
import { Download, FileText } from "lucide-react";
import { useVendorAuth, vendorFetch } from "./VendorAuthContext";
import { API_BASE } from "../DataContext";

const kb = (n) => (n / 1024).toFixed(1) + " KB";
const fmtDate = (iso) => (iso ? iso.slice(0, 10).split("-").reverse().join("-") : "—");

const TYPE_CLR = {
  "Purchase Order": "bg-sky-100 text-sky-700",
  "PO Revision": "bg-amber-100 text-amber-700",
  "Debit Note": "bg-red-100 text-red-700",
  "Credit Note": "bg-emerald-100 text-emerald-700",
  Other: "bg-slate-100 text-slate-700",
};

export default function VendorDocuments() {
  const { token } = useVendorAuth();
  const [docs, setDocs] = useState(null);

  useEffect(() => {
    vendorFetch(token)("/api/vendor/documents").then((r) => r.json()).then(setDocs);
  }, [token]);

  const download = async (d) => {
    const r = await fetch(`${API_BASE}/api/vendor/documents/${d.id}/download`, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) return alert("Download failed");
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = d.filename || d.title;
    document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-4" data-testid="vendor-documents">
      <div>
        <h1 className="text-2xl md:text-3xl font-black text-[#0a2a5e]">Documents</h1>
        <p className="text-sm text-slate-500 mt-1">Purchase Orders, revisions, debit and credit notes shared by BAISHALII.</p>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm">
        {!docs && <div className="px-4 py-8 text-center text-slate-400 text-sm">Loading…</div>}
        {docs && docs.length === 0 && (
          <div className="px-4 py-12 text-center">
            <div className="mx-auto h-14 w-14 rounded-full bg-slate-100 flex items-center justify-center mb-3">
              <FileText className="h-6 w-6 text-slate-400" />
            </div>
            <p className="font-semibold text-slate-700 mb-1">No documents yet</p>
            <p className="text-sm text-slate-500">Documents shared by BAISHALII (POs, revisions, notes) will appear here.</p>
          </div>
        )}
        <div className="divide-y divide-slate-100">
          {docs?.map((d) => (
            <div key={d.id} className="flex items-center gap-4 p-4 hover:bg-sky-50/50">
              <div className="h-10 w-10 rounded-lg bg-slate-100 flex items-center justify-center flex-shrink-0">
                <FileText className="h-5 w-5 text-slate-500" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-slate-800 truncate">{d.title}</div>
                <div className="text-xs text-slate-500 truncate">{d.filename} · {kb(d.size || 0)} · {fmtDate(d.created_at)}</div>
              </div>
              <span className={`hidden sm:inline-block px-2.5 py-1 rounded-full text-xs font-semibold ${TYPE_CLR[d.doc_type] || TYPE_CLR.Other}`}>{d.doc_type}</span>
              <button onClick={() => download(d)} data-testid={`vendor-doc-dl-${d.id}`} className="text-[#0a2a5e] hover:bg-slate-100 p-2 rounded-lg" title="Download"><Download className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
